/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/first */
import 'js/lib/jquery/jquery-1.8.3.min';
import './shim-version-1.9.1';
import 'bootstrap';
import 'js/lib/jquery/plugins/jquery.tmpl';
import 'js/lib/jquery.ui/jquery-ui-1.9.2.min';
import 'js/lib/jquery.ui/jquery-ui-i18n.custom.min';
import 'js/lib/jquery/plugins/jquery.validate.min';
import 'js/lib/jquery/plugins/jquery.unobtrusive-ajax.min';
import 'js/lib/jquery/plugins/jquery.validate.unobtrusive.min';
import 'js/common/jquery-validator-extend';
import './plugins/jquery-error-handler';
import 'js/app/plugins/jquery.utils';
